// extracted by mini-css-extract-plugin
export default {"queries":"queries_queries__ruKxR","container":"queries_container__bPhIl","card":"queries_card__gjWB-","queryImage":"queries_queryImage__WZePF"};